import SuperJSON from "superjson";
import Id from "../types/Id";

export default class SubformId extends Id<"subform"> {}

SuperJSON.registerClass(SubformId);
